import { isNil } from 'ramda';
import { useEffect } from 'react';

import { SubscriberSettingsMode } from '~features/subscribers/subscribersSlice';
import { BusinessUnit } from '~models/businessUnit';
import { Subscriber } from '~models/subscriber';
import { mapBooleanFieldValueToNumber, mapNumberFieldValueToBoolean } from '~utils/forms';

import { ModesSettings } from './config';

export const useSettingsModeChange = (
  id: Subscriber['id'],
  businessUnitId: BusinessUnit['id'],
  subscriber: Subscriber,
  values: ModesSettings,
  mode: SubscriberSettingsMode,
  fieldName: keyof Omit<ModesSettings, 'route' | 'manualPath'>,
  onUpdateMode,
  setFieldValue: (field: string, value) => void,
  status?: 'updated' | null,
) => {
  useEffect(() => {
    if (
      isNil(values[fieldName]) ||
      mapBooleanFieldValueToNumber(values[fieldName]) === subscriber.settings?.modes[fieldName]
    ) {
      return;
    }

    if (isNil(status)) {
      setFieldValue('intelliTap', mapNumberFieldValueToBoolean(subscriber?.settings?.modes?.intelliTap as number));
      setFieldValue('lineCut', mapNumberFieldValueToBoolean(subscriber?.settings?.modes?.lineCut as number));
      setFieldValue('repeater', mapNumberFieldValueToBoolean(subscriber?.settings?.modes?.repeater as number));
    }

    onUpdateMode({
      values: { [fieldName]: mapBooleanFieldValueToNumber(values[fieldName]) },
      id,
      businessUnitId,
      mode,
      fieldName,
    });
  }, [values[fieldName]]);
};
